export type AdminThemeMode = "light" | "dark";

export type AdminTheme = {
  mode: AdminThemeMode;
  colors: {
    background: string;
    surface: string;
    surfaceMuted: string;
    surfaceElevated: string;
    border: string;
    borderStrong: string;
    text: string;
    textMuted: string;
    textSoft: string;
    primary: string;
    primarySoft: string;
    primaryStrong: string;
    success: string;
    warning: string;
    danger: string;
    sidebar: string;
    sidebarText: string;
    sidebarActive: string;
    sidebarActiveBg: string;
    shadow: string;
  };
};

export const adminThemes: Record<AdminThemeMode, AdminTheme> = {
  light: {
    mode: "light",
    colors: {
      background: "#f5f7fb",
      surface: "#ffffff",
      surfaceMuted: "#f8fafc",
      surfaceElevated: "#ffffff",
      border: "#e2e8f0",
      borderStrong: "#cbd5e1",
      text: "#0f172a",
      textMuted: "#64748b",
      textSoft: "#94a3b8",
      primary: "#2563eb",
      primarySoft: "#dbeafe",
      primaryStrong: "#1d4ed8",
      success: "#16a34a",
      warning: "#f59e0b",
      danger: "#ef4444",
      sidebar: "#0f172a",
      sidebarText: "#cbd5e1",
      sidebarActive: "#ffffff",
      sidebarActiveBg: "rgba(255, 255, 255, 0.1)",
      shadow: "0 24px 60px rgba(15, 23, 42, 0.08)",
    },
  },
  dark: {
    mode: "dark",
    colors: {
      background: "#020617",
      surface: "#0f172a",
      surfaceMuted: "#111827",
      surfaceElevated: "#1e293b",
      border: "#1e293b",
      borderStrong: "#334155",
      text: "#f8fafc",
      textMuted: "#cbd5e1",
      textSoft: "#64748b",
      primary: "#60a5fa",
      primarySoft: "rgba(96, 165, 250, 0.16)",
      primaryStrong: "#93c5fd",
      success: "#22c55e",
      warning: "#fbbf24",
      danger: "#f87171",
      sidebar: "#020617",
      sidebarText: "#94a3b8",
      sidebarActive: "#ffffff",
      sidebarActiveBg: "rgba(96, 165, 250, 0.16)",
      shadow: "0 24px 60px rgba(0, 0, 0, 0.32)",
    },
  },
};
